import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Style/navbar.css";
import { useTranslation } from "react-i18next";
import { AppLanguage } from "../context/ApplicationLanguage";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);
  const appLang = useContext(AppLanguage);

  // إغلاق القائمة عند التنقل إلى صفحة أخرى
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // إغلاق القائمة عند النقر خارج الناف بار
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target.closest(".menu-toggle")
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // التبديل اليدوي بين العربية والإنجليزية (اختياري)
const toggleLanguage = () => {
  let newLang;
  if (i18n.language === "en") {
    newLang = "ar";
  } else if (i18n.language === "ar") {
    newLang = "he";
  } else {
    newLang = "en";
  }
  appLang.changeLanguage(newLang);
  i18n.changeLanguage(newLang);
};

  // فتح / إغلاق القائمة
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <span className="navbar-item logo-text">
          <img src="/AlwaleedStone.png" alt="icon" className="logo-image" />
        </span>
      </div>

      <div ref={menuRef} className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
        <Link to="/home" className="navbar-item">
          {t("home")}
        </Link>
        <Link to="/projects" className="navbar-item">
          {t("projects")}
        </Link>
        <Link to="/stone-types" className="navbar-item">
          {t("stoneTypes")}
        </Link>
        <Link to="/AboutUs" className="navbar-item">
          {t("AboutUs")}
        </Link>
        <Link to="/cart" className="navbar-item">
          {t(" 🛒")}
        </Link>

        {/* زر تغيير اللغة داخل القائمة */}
        <select
          value={i18n.language}
          onChange={(e) => {
            const newLang = e.target.value;
            appLang.changeLanguage(newLang);
            i18n.changeLanguage(newLang);
          }}
          className="language-toggle"
          
        >
          <option value="en">EN</option>
          <option value="ar">AR</option>
          <option value="he">He</option>
        </select>
      </div>

      {/* زر القائمة (☰) يظهر في الشاشات الصغيرة */}
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>
    </nav>
  );
};

export default Navbar;
